// extracted by mini-css-extract-plugin
export var searchHeader = "_8p-0";
export var searchHeaderDark = "_8p-1";